import ModelMappingValueOrigin from "~/models/mapping/modelMappingValueOrigin";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import ModelMappingOriginObjectModel from "~/models/mapping/modelMappingOriginObjectModel";
import {
  ObjectModelPropertyName,
  ObjectModelPropertyRootType
} from "~/enums/objectModelPropertyType";
import ModelMappingOriginRelationIdentifier from "~/models/mapping/modelMappingOriginRelationIdentifier";
import {
  ObjectModelBuiltinPropertyPermissions,
  ObjectModelBuiltinPropertyType,
} from "~/enums/objectModelBuiltinPropertyType";
import {EnumHelper} from "~/helpers/enumHelper";
import {accessDisplay} from "~/enums/accessPermission";
import ObjectModelPropertyDefinition from "~/models/objectModelProperties/objectModelPropertyDefinition";
import {PickListSelectionType} from "~/enums/pickListSelectionType";
import {FileAttachmentType} from "~/enums/fileAttachmentType";
import {DimensionalType} from "~/enums/dimensionalType";

export default class ModelMappingValueOriginObjectModelProperty extends ModelMappingValueOrigin<ObjectModelProperty, ModelMappingOriginObjectModel | ModelMappingOriginRelationIdentifier> {
  get origin(): ObjectModelProperty {
    return ObjectModelProperty.repo.find(this.id)
  }

  get value() {
    if (this.isBuiltIn){
      return ObjectModelPropertyDefinition.mappingValueBuiltInOption(this.id, this.modelMappingOrigin.sourceBuiltInSetNumberForMappingValue)
    } else {
      const omp = this.origin;
      if (!omp) return null
      return ObjectModelPropertyDefinition.mappingValueOption(omp)
    }
  }

  get valueType(): string {
    if (this.isBuiltIn) {
      return accessDisplay(ObjectModelBuiltinPropertyPermissions[this.id]);
    } else if (!!this.origin) {
      if (this.origin.isReadOnly) {
        return accessDisplay(this.origin.permissions)
      } else {
        return ObjectModelPropertyName(this.origin);
      }
    }
    return null;
  }

  get enumValueType(): ObjectModelPropertyRootType {
    if (this.origin) {
      return this.origin.property_type as ObjectModelPropertyRootType
    }
  }

  get isIndexed(): boolean {
    if (!this.origin) return false
    return this.modelMappingOrigin.model.indexed_property_client_ids.includes(this.origin.client_id)
  }

  get isUploader(): boolean {
    if (!this.origin) return false
    return this.origin.is(ObjectModelPropertyRootType.FileAttachment);
  }

  get isRecordId(): boolean {
    return this.isBuiltIn && this.id.toString() === ObjectModelBuiltinPropertyType.RecordId.toString()
  }

  get isBuiltIn(): boolean {
    return EnumHelper.toArray(ObjectModelBuiltinPropertyType).map(x => `${x}`).includes(this.id)
  }

  get isSinglePicklist(): boolean {
    return this.enumValueType === ObjectModelPropertyRootType.PickList &&
      this.origin.selection_type === PickListSelectionType.SingleSelect
  }

  get isMultiPicklist(): boolean {
    return this.enumValueType === ObjectModelPropertyRootType.PickList &&
      this.origin.selection_type === PickListSelectionType.MultiSelect
  }

  get originType() {
    return this.origin?.property_type
  }

  get fileDimensionalType(): DimensionalType {
    if (!this.isUploader) { return null; }

    switch(this.origin.file_attachment_type) {
      case FileAttachmentType.SingleFile:
        return DimensionalType.Single;
      case FileAttachmentType.MultipleFiles:
        return DimensionalType.Multi;
    }
  }
}